import * as React from 'react';

import { PlayFillInBlankQuestion } from '../../../Shared';
import { getGradedResponsesWithCallback, saveResponseToCMS } from '../../actions/responses.js';
import { FillInBlankQuestion } from '../../interfaces/questions';
import FeedbackContainer from '../renderForQuestions/feedback';
import { CONNECT } from '../../../Shared/utils/constants';

interface PlayFillInTheBlankQuestionProps {
  conceptsFeedback: any;
  dispatch: () => void;
  isLastQuestion: boolean;
  key: string;
  language?: string;
  languageLocale?: string;
  nextQuestion: () => void;
  onHandleToggleQuestion: (question: FillInBlankQuestion) => void;
  prefill: any;
  previewMode: boolean;
  question: FillInBlankQuestion;
  setResponse: (response: Response) => void;
  showTranslation: boolean;
  submitResponse?: (response: any) => void;
  translate: (language: string) => string;
}

export class PlayFillInTheBlankQuestionWrapper extends React.Component<PlayFillInTheBlankQuestionProps> {
  updateResponseResourceBound = (returnValue: any, questionID: string, attempts: any, dispatch: any) => {
    const latestAttempt = attempts ? attempts[attempts.length - 1] : undefined
    const isFirstAttempt = !latestAttempt;
    dispatch(saveResponseToCMS(returnValue.response, isFirstAttempt));
  }

  render() {
    return (
      <PlayFillInBlankQuestion
        {...this.props}
        FeedbackContainer={FeedbackContainer}
        getGradedResponsesWithCallback={getGradedResponsesWithCallback}
        mode={CONNECT}
        updateResponseResource={this.updateResponseResourceBound}
      />
    );
  }
}

export default PlayFillInTheBlankQuestionWrapper;
